import React, { useCallback, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom'
import { signInWithGoogle } from '../../../utils/firebase';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Styles from '../../../styles/Forms.module.css'
import FormSide from '../../../images/form_side.webp'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { isValidEmail } from '../../../utils/strings';
import GoogleLogo from '../../../images/google_logo.webp'
import { recoverPassword } from '../../../utils/firebase';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

export default function RecoverPassword() {
    const navigate = useNavigate();

    const [email, setEmail] = useState('')
    const [emailSend, setEmailSend] = useState(false)
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()

    const onRecoverPassword = useCallback(() => {
        if (isValidEmail(email)) {
            recoverPassword(email)
            setEmailSend(true)
        }
    }, [email])

    if (userAuth === null) {
        return <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>

    } else if (userAuth) {
        navigate("/admin/app")

    } else {
        return (
            <div className={Styles.container}>
                <Stack
                    direction='row'
                    flexWrap='wrap'
                    justifyContent='center'
                    className={Styles.content}
                >
                    <Stack
                        spacing={3}
                        className={Styles.form}
                    >
                        <Typography onClick={() => navigate('/')}>
                            TookEat
                        </Typography>
                        <Typography variant='h4'>
                            Recupera tu contraseña
                        </Typography>

                        <Divider />

                        <TextField
                            label="Email"
                            variant="outlined"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            error={!isValidEmail(email) && email !== ''}
                            required
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    onRecoverPassword()
                                }
                            }}
                        />

                        {!emailSend ?
                            <Button variant="contained" onClick={() => onRecoverPassword()}>
                                Enviar email de recuperación
                            </Button> :
                            <>
                                <Typography variant='h6'>
                                    Email enviado! Revisa tu casilla de correo electronico para encontrar el email de recuperación de contraseña
                                </Typography>
                                <Button variant="contained" onClick={() => navigate('/admin/login')}>
                                    Ingresar
                                </Button>
                            </>}


                        <Divider>Tambien puedes</Divider>

                        <Button
                            variant="outlined"
                            onClick={signInWithGoogle.bind(this)}
                        >
                            <img src={GoogleLogo} className={Styles.loginMethodLogo} alt='google logo' />
                            Ingresar con Google
                        </Button>

                        <Stack direction='row' justifyContent='center' spacing={2}>
                            <Typography variant='body1'>
                                <span className={Styles.actionText}
                                    onClick={() => navigate('/admin/signup')}>
                                    Crea una cuenta nueva
                                </span>
                            </Typography>
                            <Typography variant='body1'>
                                <span className={Styles.actionText}
                                    onClick={() => navigate('/admin/login')}>
                                    Ingresa a tu cuenta
                                </span>
                            </Typography>
                        </Stack>

                    </Stack>
                    <div className={Styles.sideImage} style={{ backgroundImage: 'url(' + FormSide + ')' }}></div>
                </Stack>
            </div>
        )
    }
}